import Box from '@mui/material/Box';
import Hidden from '@mui/material/Hidden';
import Radio from '@mui/material/Radio';
import { styled, useTheme } from '@mui/material/styles';
import { StyledFormSelected, StyledRadioCheckIcon, StyledRadioIcon } from '../SdsScaleQuestion';

interface SectionProps {
  possibleAnswersAndText: any;
  controlProps: any;
}

const StyledTitleBox = styled(Box)(() => ({
  width: '50%',
  height: '30px',
}));

export default function SectionThree({ possibleAnswersAndText, controlProps }: SectionProps) {
  const theme = useTheme();

  const renderAnswers = () => {
    return possibleAnswersAndText.answers.map((item: string) => {
      return (
        <StyledFormSelected
          key={item}
          value={item}
          labelPlacement="start"
          control={
            <Radio
              checkedIcon={<StyledRadioCheckIcon>{item}</StyledRadioCheckIcon>}
              icon={
                <StyledRadioIcon sx={{ backgroundColor: theme.xPalette.background }}>
                  {item}
                </StyledRadioIcon>
              }
              {...controlProps(item)}
            />
          }
          label={
            <Hidden xlDown xlUp>
              {item}
            </Hidden>
          }
        />
      );
    });
  };

  return (
    <Box
      sx={{
        minWidth: '340px',
        maxWidth: '340px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        mt: 4,
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: '10px',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          columnGap: 2,
          mr: 2,
          textAlign: 'right',
        }}
      >
        {possibleAnswersAndText.texts.map((item: string) => (
          <StyledTitleBox key={item}>{item}</StyledTitleBox>
        ))}
      </Box>
      <Box
        sx={{
          width: '100%',
          height: '40px',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          position: 'absolute',
          bottom: '68px',
          '&:after': {
            content: '""',
            position: 'absolute',
            width: '30px',
            left: 0,
            bottom: '-0.2px',
            borderBottom: `1px solid ${theme.xPalette.black}`,
          },
        }}
      >
        <Box
          sx={{
            width: '26%',
            height: '40px',
            border: `1px solid ${theme.xPalette.black}`,
            borderRight: 0,
          }}
        ></Box>
        <Box
          sx={{
            width: '26%',
            height: '40px',
            border: `1px solid ${theme.xPalette.black}`,
          }}
        ></Box>
        <Box
          sx={{
            width: '26%',
            height: '40px',
            borderBottom: `1px solid ${theme.xPalette.black}`,
            '&:after': {
              content: '""',
              position: 'absolute',
              width: 0,
              height: 0,
              right: '58px',
              bottom: '-3px',
              borderTop: '4px solid transparent',
              borderBottom: '4px solid transparent',
              borderLeft: `5px solid ${theme.xPalette.shadeGrey}`,
            },
          }}
        ></Box>
      </Box>
      <Box
        sx={{
          width: '350px',
          height: '140px',
          display: 'flex',
          justifyContent: 'space-around',
          flexWrap: 'wrap',
        }}
      >
        {renderAnswers()}
      </Box>
    </Box>
  );
}
